import React, { useState,Component } from 'react';
import {useTranslation} from 'react-i18next'
import Slider from "react-slick";
let cacheplacement:any= 0;

export default function PlacementItem(props:any){
    let{t} = useTranslation()
    if(sessionStorage.getItem("placement")){
      cacheplacement =  sessionStorage.getItem("placement")
    }
    const [layout, setLayout] = useState(parseInt(cacheplacement));
    const settings:any = {
      arrows:false,
      dots: true,   
      slidesToShow:3,
      slidesToScroll: 1,
      className: "center",
      centerPadding: "0px",
      centerMode: false,
      infinite: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            slidesToScroll:1,
            initialSlide: 1,
            infinite: false,
            dots: true,
            centerPadding: "180px",
            centerMode: true,
            arrows:false, 
          }
        },
        {
          breakpoint: 840,
          settings: {
            slidesToShow: 1,
            slidesToScroll:1,
            initialSlide: 1,
            infinite: false,
            dots: true,
            centerPadding: "180px",
            centerMode: true,
            arrows:false, 
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll:1,
            initialSlide: 1,
            infinite: false,
            dots: true,
            centerPadding: "80px",
            centerMode: true,
            arrows:false, 
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerPadding: "32px",
            centerMode: true,
            arrows:false,
            infinite: false
          }
        }
      ]
    };
    const onSelectItem=(id:string)=>{
      setLayout(parseInt(id))
      props.onSelectPlacement(parseInt(id))
    }
    const onSelectRadio=(e:any)=>{
      const {value,name} = e.target 
      if(e.target.checked){
        setLayout(parseInt(value))
        props.onSelectPlacement(value)
      }
    }
    return (
      <div className=" my-5 mb-2">
        <Slider {...settings}>
          <div onClick={()=>onSelectItem("1")}>
            <div className={`placement-item m-auto ${(layout===1)?"bg-red":""}`}>
              <div className="images">
                  <img src="images/placement1.jpg" alt=""/>
              </div>
              <div className={`title-block  ${(layout===1)?"bg-red":""}`} >
                <div className="m-auto display-inline-block">
                  <input type="radio" className="radio-btn" name="choice" id="a-opt1" value={1} checked={(layout===1)?true:false} onChange={onSelectRadio}/>
                  <label htmlFor="a-opt1" className="radio">{t("modern")}</label>
                </div>
              </div>
            </div>
          </div>
        <div  onClick={()=>onSelectItem("2")}>
          <div className={`placement-item m-auto ${(layout===2)?"bg-red":""}`}>
            <div className="images">
                <img src="images/placement2.jpg" alt=""/>
            </div>
            <div className={`title-block  ${(layout===2)?"bg-red":""}`}>
              <div className="m-auto display-inline-block">
                <input type="radio" className="radio-btn" name="choice" id="a-opt2" value={2} checked={(layout===2)?true:false} onChange={onSelectRadio}/>
                <label htmlFor="a-opt2" className="radio">{t("bright")}</label>
              </div>
            </div>
          </div>
        </div>
        <div  onClick={()=>onSelectItem("3")}>
          <div className={`placement-item m-auto ${(layout===3)?"bg-red":""}`}>
            <div className="images">
                <img src="images/placement3.jpg" alt=""/>
            </div>
            <div className={`title-block  ${(layout===3)?"bg-red":""}`}>
              <div className="m-auto display-inline-block">
                <input type="radio" className="radio-btn" name="choice" id="a-opt3" value={3} checked={(layout===3)?true:false} onChange={onSelectRadio}/>
                <label htmlFor="a-opt3" className="radio">{t("classic")}</label>
              </div>
            </div>
          </div>
        </div>
        </Slider>
      </div>
    );
  }
